import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@/shared/lib/cn'

import { useOfferCardHighRatingTag } from '../../model/useOfferCardHighRatingTag.ts'

interface OfferCardHighRatingTagProps {
	className?: string
}

/**
 * Component for show high rating tag on offer card
 *
 * @author Ivan Shchedrovskyi
 */
export const OfferCardHighRatingTag = memo(
	({ className }: OfferCardHighRatingTagProps) => {
		const { t } = useTranslation('home-page')

		const { highRating } = useOfferCardHighRatingTag()

		if (!highRating) return null

		return (
			<span
				className={cn(
					'bg-primary-100 absolute top-3 right-4 z-2 rounded-md px-3 py-1.5 text-white',
					className
				)}
			>
				{t('highRating')}
			</span>
		)
	}
)

OfferCardHighRatingTag.displayName = 'OfferCardHighRatingTag'
